import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function InformationCircleIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path fill="currentColor" d="M11 7h2v2h-2zM11 11h2v6h-2z" />
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
        </SvgIcon>
    )
}
